import axiosInstance from "../../../myAxiosInstance";
const baseApiUrl = process.env.REACT_APP_HOST + process.env.REACT_APP_BASE_API_URL;

/**
 * Method to get all properties
 * @param {Object} data
 */
async function markPropertyRerented(data) {
    try {
        const result = await axiosInstance.post(`${baseApiUrl}admin/houses/mergeHouses`, data);
        return result;
    } catch (err) {
        console.error('error in merging properties ', err);
    }

};

async function markRerentingStatus(id, value) {
    try {
        const result = await axiosInstance.patch(`${baseApiUrl}admin/leases/${id}/markRerentingStatus`, value);
        return result;
    }
    catch (err) {
        console.error("error in marking Lease status")
    }

};

async function updateBeatsListingId(id, value) {
    try {
        const result = await axiosInstance.patch(`${baseApiUrl}admin/houseOfferings/${id}/updateNewBeatsListingIdentifier`, value);
        return result;
    }
    catch (err) {
        console.error("error in updating NewBeatsListingIdentifier")
    }

}

export const RerentingTrackerServices = {
    markPropertyRerented,
    markRerentingStatus,
    updateBeatsListingId
};